import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { getLangCountryPrefix } from 'helpers/utils';

import { BUSINESS_HELP, BUSINESS_HELP_PAYSEND, HELP } from '../../../constants/UrlConstants';
import promoColors from '../../../theme/promoColors';
import promoMedia from '../../../theme/promoMedia';
import { PromoText } from '../common/PromoText/PromoText';

const FooterNavigation = styled.nav`
    margin-bottom: 32px;

    ul {
        li a:hover {
            color: ${promoColors.gray40};
        }

        li a:focus-visible {
            background-color: ${promoColors.gray20};
            border-radius: 2px;
            outline: 1px dashed ${promoColors.gray40};
        }

        li + li {
            margin-top: 32px;
        }

        ${promoMedia.desktop1440} {
            display: flex;
            text-align: center;

            li + li {
                margin-top: 0;
                margin-left: 40px;
            }
        }
    }
`;

const FooterNav = (props) => {
    const getHref = (url, linkToNav) => {
        if (url === HELP || url === `${getLangCountryPrefix(props.lang, props.country)}${HELP}`) {
            return `${getLangCountryPrefix(props.lang, props.country)}${HELP}`;
        } else if (url === BUSINESS_HELP || url === `${getLangCountryPrefix(props.lang, props.country)}${BUSINESS_HELP}`) {
            return BUSINESS_HELP_PAYSEND;
        }
        return linkToNav;
    };

    const getLinks = (linksArray, lang, country, isLanding) => {
        return linksArray.map((link) => {
            const { name, url, isBlank, id } = link;
            const regexRes = /^\/resources/g;
            const isLinkHaveRegexRes = url.search(regexRes);
            const regexTerm = /^(\/(ga|grow)\/term)|(\/\/cloud.paysend.com)/g;
            const isLinkHaveRegexTerm = url.search(regexTerm);
            const hrefLink = !isLinkHaveRegexRes || !isLinkHaveRegexTerm ? url : `${getLangCountryPrefix(lang, country)}${url}`;
            const dataTestAttr = `footer-nav-link-${url.replace(/\//g, '')}`;
            return (
                <li key={`${id}${url.replace(/\s/g, '')}`}>
                    {isLanding ? (
                        <a data-testid={dataTestAttr} href={getHref(url, `${getLangCountryPrefix(lang, country)}${url}`)}>
                            {name}
                        </a>
                    ) : (
                        <a href={getHref(url, hrefLink)} target={isBlank ? '_blank' : '_self'}>
                            {name}
                        </a>
                    )}
                </li>
            );
        });
    };

    return (
        <PromoText tag="div" color="gray80">
            <FooterNavigation>
                <ul>{props.links && Array.isArray(props.links) ? getLinks(props.links, props.lang, props.country, props.isLanding) : <></>}</ul>
            </FooterNavigation>
        </PromoText>
    );
};

FooterNav.propTypes = {
    lang: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    links: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
            isBlank: PropTypes.bool,
        }),
    ),

    isLanding: PropTypes.bool,
};

export default FooterNav;
